import React, { Component } from 'react'
import InlineEditingGrid from '../../components/panels/InlineEditing/InlineEditingGrid.js'
import ErrorBoundary from './Error.js'

// display the page
class FixErrorsAndWarningPage extends Component {

  componentDidMount() {
    if(typeof _satellite !== 'undefined')
      window._satellite.track('cbTrack.viewInDom')
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="cb-panel-white">
              <h2>Fix Errors and Warnings </h2>
              <ErrorBoundary>
                <InlineEditingGrid apiAuthHeaders={this.props.apiAuthHeaders} requestData={this.props.fDataItems}/>
              </ErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default FixErrorsAndWarningPage